import React, { useEffect, useRef } from 'react';

type VideoStreamProps = {
  stream: MediaStream;
  muted?: boolean;
  className?: string;
};

const VideoStream: React.FC<VideoStreamProps> = ({ stream, muted = false, className }) => {
  const ref = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.srcObject = stream;
    // On mobile browsers/webviews, autoplay can be blocked unless we explicitly call play().
    // If muted=true, play() is generally allowed even without a user gesture.
    const p = ref.current.play?.();
    if (p && typeof (p as any).catch === 'function') {
      (p as Promise<void>).catch(() => {});
    }
  }, [stream, muted]);

  return (
    <video
      ref={ref}
      autoPlay
      playsInline
      muted={muted}
      className={className ?? 'w-full h-full object-cover'}
    />
  );
};

export default VideoStream;
